import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasReportedesaldosfacturacionListaComponent () {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.seleccionar = seleccionar

  function $onInit () {
    $ctrl.seleccionado = null
  }

  function seleccionar (item) {
    if (item) {
      $ctrl.seleccionado = item
    } else {
      $ctrl.seleccionado = null
    }
  }
}

module.component('finanzasReportedesaldosfacturacionLista', {
  controller: FinanzasReportedesaldosfacturacionListaComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/reportedesaldosfacturacion/components/lista/component.js